import { FILE_BASE_URL } from "@/common/const";
import { dayjs } from "element-plus";

export const createUUID = (len = 32, prefix = "u") => {
  let uuid = prefix || "";
  for (let index = uuid.length; index < len; index++) {
    uuid += Math.floor(Math.random() * 32).toString(32)
  }
  return uuid
}

export const getClientonly = () => {
  let clientonly = localStorage.getItem('clientonly')
  if (!clientonly) {
    clientonly = createUUID()
    localStorage.setItem('clientonly', clientonly)
  }
  return clientonly
}

export const formatDay = (date) => dayjs(date).format("YYYY-MM-DD")

export const formatTime = (date) => dayjs(date).format("YYYY-MM-DD HH:mm:ss")

export const fileUrl = (url) => {
  if (!url) return ''
  return url.indexOf("http") === 0 ? url : `${FILE_BASE_URL}/${url}`
}